import React from "react";
import {
  withStyles,
  Typography,
  Paper,
  Dialog,
  CircularProgress
} from "@material-ui/core";
import { observer } from "mobx-react";
import "../../styles/LoadingRipley.scss";
import appStore from "./../../stores/AppStore";

const styles = theme => ({
  progress: {
    margin: theme.spacing(2),
    color: "#8C4799"
  }
});


const loadingComponente = withStyles(styles)(observer(
  class LoadingRipleyComponent extends React.Component {
    render() {
      const { classes } = this.props;
      return (
        <Dialog id="modal" open={appStore.loadingMsj}>
          <div className="contenedorMensajeCarga">
            <Paper id="paperModal" className="cajaInfo">
              <Typography id="txtModal" className="mensajeCarga">
                {appStore.mensajeLoading}
              </Typography>
            </Paper>
            <div>
              <CircularProgress
                id="CircularProgress"
                status="loading"
                className={classes.progress}
                size={50}
                thickness={5}
              />
            </div>
            <div className="franjaColores">
              <div className="rojo" />
              <div className="amarillo" />
              <div className="morado" />
            </div>
          </div>
        </Dialog>
      );
    }
  }));

export default loadingComponente;
